import axios from '@/utils/axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'
import {isEmpty, get, find, first, sortBy} from 'lodash';

// state
export const state = {
  currentResource: null,
  availableResources: [],
  createdResources: []
};

// getters
export const getters = {
  currentResource: state => state.currentResource,
  availableResources: state => state.availableResources,
  createdResources: state => state.createdResources
};

// mutations
export const mutations = {
  [types.UPDATE_RESOURCE](state, resource) {
    state.currentResource = resource;
    Cookies.set('resource', resource.key, {expires: 365})
  },

  [types.SET_CREATED_RESOURCES](state, resources) {
    state.createdResources = resources;
  },

  [types.FETCH_RESOURCES_SUCCESS](state, {availableResources}) {
    state.availableResources = availableResources;
  },

  [types.DELETE_DEFAULT_RESOURCE](state) {
    state.currentResource = null;
    Cookies.remove('resource', {path: ''});
  },

  [types.SET_WALLKIT_RESOURCE](state) {
    state.currentResource = {
      host: "https://dev.wallkit.net",
      key: "35D02754-9A51-2C23-A5F7-79970C4",
      title: "WALLKIT"
    };
    Cookies.set('resource', get(state.currentResource, 'key'));
  },

  [types.SET_DEFAULT_RESOURCE](state) {
    return new Promise(resolve => {
      const resourceFromCookie = find(state.availableResources, {key: Cookies.get('resource')});

      const firstFromCookie = first(state.availableResources);

      if (!isEmpty(resourceFromCookie)) {
        state.currentResource = resourceFromCookie;
      }
      else {
        state.currentResource = firstFromCookie;
      }

      Cookies.set('resource', get(state.currentResource, 'key'));
      resolve(state.currentResource);
    });
  },

};

// actions
export const actions = {

 updateResource({commit, dispatch}, payload) {
    const resource = find(state.availableResources, {key: payload});

    if (resource) {
      commit(types.UPDATE_RESOURCE, resource)
    } else {
      commit(types.SET_DEFAULT_RESOURCE)
    }
  },

  async fetchResources({commit}) {
    try {
      const {data} = await axios.get('/admin/available-resources?sort=desc');
      const availableResources = sortBy(data.items, [item => item.title]);
      commit(types.FETCH_RESOURCES_SUCCESS, {availableResources})
    } catch (e) {
      commit(types.FETCH_RESOURCES_FAILURE)
    }
  },
  async setCreatedResources ({commit}, payload) {
    commit(types.SET_CREATED_RESOURCES, payload)
  },
  async setDefaultResource({commit}) {
    commit(types.SET_DEFAULT_RESOURCE)
  },
  async setWallkitResource ({commit}) {
    commit(types.SET_WALLKIT_RESOURCE)
  },
  async deleteDefaultResource({commit}) {
    commit(types.DELETE_DEFAULT_RESOURCE)
  },
  async updateResourceData({state, commit}, payload) {
    const targetResource = state.availableResources.find((item) => item.key === payload.key);

    if (targetResource) {
      commit(types.UPDATE_RESOURCE, payload);
    }
  }

};
